const form = {
  formId: "new-user-form",
  formField: {
    quarter: {
      name: "quarter",
      label: "[01] Kỳ tính thuế: Quý",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng nhập quý",
    },
    year: {
      name: "year",
      label: "Năm",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng nhập năm",
    },
    firstTime: {
      name: "firstTime",
      label: "[02] Lần đầu:",
      type: "text",
    },
    supplementaryForThe: {
      name: "supplementaryForThe",
      label: "[03] Bổ sung lần thứ:",
      type: "number",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập bổ sung lần thứ",
      invalidMsg: "Số không hợp lệ",
    },
    taxpayerInstead: {
      name: "taxpayerInstead",
      label: "[04] Bên Việt Nam khấu trừ và nộp thuế thay:",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập bên Việt Nam khấu trừ và nộp thuế thay",
    },
    taxpayerInsteadId: {
      name: "taxpayerInsteadId",
      label: "[05] Mã số thuế nộp thay của bên Việt Nam:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế nộp thay của bên Việt Nam",
      invalidMsg: "Mã số thuế không hợp lệ",
    },

    foreignNrganizationName: {
      name: "foreignNrganizationName",
      label: "[06] Tên tổ chức nhận tái bảo hiểm nước ngoài:",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập tên tổ chức nhận tái bảo hiểm nước ngoài",
    },
    countryName: {
      name: "countryName",
      label: "[07] Nước cư trú:",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng chọn nước cư trú",
    },
    address: {
      name: "address",
      label: "[08] Địa chỉ trụ sở chính tại nước ngoài:",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập địa chỉ trụ sở chính tại nước ngoài",
    },

    taxAgencyName: {
      name: "taxAgencyName",
      label: "[09] Tên đại lý thuế (nếu có):",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập tên người nộp thuế",
    },
    taxAgencyId: {
      name: "taxAgencyId",
      label: "[10] Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },

    fullName: {
      name: "fullName",
      label: "Họ và tên",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập họ và tên",
    },
    certificate: {
      name: "certificate",
      label: "Chứng chỉ hành nghề số:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập chứng chỉ hành nghề số",
    },
    signer: {
      name: "signer",
      label: "Người ký",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập người ký",
    },
    timeSign: {
      name: "timeSign",
      label: "Ngày ký",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng chọn ngày ký",
    },
  },
};

export default form;
